<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CardInfo' }" tag="button" class="active">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main" v-if="CardInfoDetailData">
          <div class="bg-box" v-if="CardInfoData">
            <ul class="text-box">
              <li class="title-box" v-if="CardInfoData.CardStatusCode == 1">
                <div class="box">
                  <div><img src="img/member-icon-1.svg" alt="" /></div>
                  <div>{{ CardInfoData.Name }}</div>
                </div>
                <div class="box">
                  <router-link :to="{ name: 'CardLost' }" tag="button">{{
                    $t("卡片掛失")
                  }}</router-link>
                  <!-- <router-link :to="{ name: 'CardInfoDetail' }" tag="button">
                    {{ $t("查看詳情") }}
                  </router-link> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="bg-box">
            <h1 v-if="CardInfoData && CardInfoData.CardNo">{{ $t("卡號:") }} {{ CardInfoData.CardNo }}</h1>
            <h1 v-else>{{ $t("卡號:") }} 未綁定</h1>
            <hr />
            <ul class="text-box">
              <li v-if="CardInfoData && CardInfoData.CardNo">
                <div>{{ $t("卡片類型") }}</div>
                <div>{{ CardInfoDetailData.CardType }}</div>
              </li>
              <li v-else>
                <div>{{ $t("卡片類型") }}</div>
                <div>QR Code</div>
              </li>
              <li>
                <div>{{ $t("姓名") }}</div>
                <div>{{ CardInfoDetailData.Name }}</div>
              </li>
              <li>
                <div>{{ $t("出生年月") }}</div>
                <div>{{ CardInfoDetailData.Birth }}</div>
              </li>
              <li>
                <div>{{ $t("性別") }}</div>
                <div>{{ CardInfoDetailData.Sex }}</div>
              </li>
              <li>
                <div>{{ $t("身份證號") }}</div>
                <div>{{ CardInfoDetailData.Ident }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="main" v-if="!CardInfoDetailData">
          <div class="bg-box">
            <ul class="text-box">
              <li class="title-box">
                <div class="box">
                  <div><img src="img/member-icon-1.svg" alt="" /></div>
                  <div>無卡片資料，請前往首頁申請</div>
                </div>
                <div class="box">
                  <router-link :to="{ name: 'Home' }" tag="button">{{
                    $t("返回首頁")
                  }}</router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "卡片掛失": "卡片掛失",
    "查看詳情": "查看詳情",
    "卡號:": "卡號:",
    "TPASS/MeNGo卡": "TPASS/MeNGo卡",
    "運費": "運費",
    "總金額": "總金額",
    "狀態": "狀態",
    "TPASS/MeNGo卡狀態": "TPASS/MeNGo卡狀態",
    "付款資訊": "付款資訊",
    "付款方式": "付款方式",
    "應付金額": "應付金額",
    "付款日期": "付款日期",
    "取卡方式": "取卡方式",
    "郵寄地址": "郵寄地址",
    "取貨站點": "取貨站點",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "卡片掛失": "Card loss",
    "查看詳情": "More",
    "卡號:": "MeN Go Card number:",
    "TPASS/MeNGo卡": "TPASS/MeNGo Card",
    "運費": "Freight",
    "總金額": "Total",
    "狀態": "Status",
    "TPASS/MeNGo卡狀態": "TPASS/MeNGo Card status",
    "付款資訊": "Payment info",
    "付款方式": "Payment",
    "應付金額": "Total",
    "付款日期": "Payment date",
    "取卡方式": "Card delivery",
    "郵寄地址": "Mailing address",
    "取貨站點": "Pickup station",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "卡片掛失": "卡片掛失",
    "查看詳情": "查看詳情",
    "卡號:": "卡號:",
    "TPASS/MeNGo卡": "TPASS/MeNGo卡",
    "運費": "運費",
    "總金額": "總金額",
    "狀態": "狀態",
    "TPASS/MeNGo卡狀態": "TPASS/MeNGo卡狀態",
    "付款資訊": "付款資訊",
    "付款方式": "付款方式",
    "應付金額": "應付金額",
    "付款日期": "付款日期",
    "取卡方式": "取卡方式",
    "郵寄地址": "郵寄地址",
    "取貨站點": "取貨站點",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "CardInfo",
  i18n,
  data() {
    return {
      CardInfoData: {},
      CardInfoDetailData: {},
    };
  },
  watch: {},
  created: function () {
    let that = this;
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/CardInfo", {
        params: {
          token: Storage.get("ek_login_token"),
        },
      })
      .then((response) => {
        this.CardInfoData = response.data.CardInfoData;
        this.CardInfoDetailData = response.data.CardInfoDetailData;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updated: function () {},
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-card-information");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CardInfo.vue